import { render, staticRenderFns } from "./vw-flat-rate-results-table-sections.vue?vue&type=template&id=df65a332&scoped=true&"
import script from "./vw-flat-rate-results-table-sections.vue?vue&type=script&lang=js&"
export * from "./vw-flat-rate-results-table-sections.vue?vue&type=script&lang=js&"
import style0 from "./vw-flat-rate-results-table-sections.vue?vue&type=style&index=0&id=df65a332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df65a332",
  null
  
)

export default component.exports